import { settings } from '../../../settings/settings-util'
import reducer from './reducers/index'
import Renderer from "./renderers/renderer"
import watch from 'redux-watch'


export default class TimeoutWarningOverlay {
    //#region Public Interface

    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        this._renderer = new Renderer(this._settings);
    }

    static getDefaultSettings() {
        return settings;
    }

    initialize(store) {
        this._store = store;
        this._renderer.initialize(store);

        let windowLocation = this._settings.stateLocations.Window.Base;
        let timeoutLocation = this._settings.stateLocations.TimeoutWarning.Base;
        let timeoutVisibleLocation = this._settings.stateLocations.TimeoutWarning.Visible;
        let stateLocation = `${windowLocation}.${timeoutLocation}.${timeoutVisibleLocation}`;
        let visibleWatcher = watch(this._store.getState, stateLocation);

        this._store.subscribe(visibleWatcher((newVal, oldVal, objectPath) => {
            if (newVal) {
                this.openWarning();
            }
            else if (!newVal && oldVal !== undefined) {
                this.openWarning();
            }
        }));
    }

    getReducer() {
        return reducer;
    }

    getRenderer() {
        return this._renderer.getRender();
    }

    //#endregion


    //#region Flag Methods

    openWarning() {
        this._focusedElementBeforeOpen = document.activeElement;
        let warning = this.getWarning();
        if (warning) {
            let yesButton = document.querySelector('.alme--window--timeout--warning__yes__button');
            if (yesButton) {
                yesButton.focus();
            }
        }
    }

    closeWarning() {
        if (this._focusedElementBeforeOpen) { this._focusedElementBeforeOpen.focus(); }
    }

    //#endregion


    //#region Helper Methods

    getWarning() {
        return document.getElementsByClassName(this._settings.classNames.timeoutWarningShadow)[0];
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/timeout-warning-overlay/src/timeout-warning-overlay.js